import React, { useState } from 'react';

import { LoginPageResolverEnum } from '../../utils/constants';
import LoginNonSsoResolver from '../reslover/LoginNonSsoresolver';
import LoginSsoResolver from '../reslover/LoginSsoResolver';
import { ILoginPageResolver, LoginPageHandlerArgType } from '../types';

const LoginPageResolver = (): {
  LoginPageToRender: React.FC;
} => {
  const [username, setUsername] = useState<string>('');
  const [strategy, setStrategy] = useState<LoginPageResolverEnum>(
    LoginPageResolverEnum.LOGIN_SSO,
  );

  const loginPageHandler = ({
    strategy,
    username,
  }: LoginPageHandlerArgType) => {
    setStrategy(strategy);
    setUsername(username);
  };

  const loginPageResolverCollection: Array<ILoginPageResolver> = [
    LoginSsoResolver({ loginPageHandler }),
    LoginNonSsoResolver({ loginPageHandler, username }),
  ];

  const pageToRender = loginPageResolverCollection.find((loginPageItem) => {
    if (loginPageItem.resolve(strategy)) {
      return loginPageItem;
    }
  });

  return {
    LoginPageToRender: !!pageToRender
      ? pageToRender.reactComponent
      : () => <></>,
  };
};

export default LoginPageResolver;
